import React, { useEffect, useState } from 'react'
import ResponseFormListHeader from '../Component/ResponseForm/ResponseFormListHeader'
import { useDetailsResponse } from '../Context/DetailsResponse';
import DetailsResponseTable from '../Component/TableDetailsResponse/DetailsResponseTable';

const DetailsResponseForm = () => {

    const { detailsResponse } = useDetailsResponse();

    const [detailsForm , setDetailsForm] = useState(null)
    const [error, setError] = useState(null);


    useEffect(()=>{

        let parsedForms = null;

        try {
            parsedForms = JSON.parse(detailsResponse.forms);
        } catch (parseError) {
            console.error("Error parsing forms JSON:", parseError);
            setError("Invalid form data received from the server");
            return;
        }

        if (!parsedForms || !parsedForms.sendToServerData) {
            console.error("Parsed forms structure is invalid");
            setError("Form data is incomplete");
            return;
        }

        setDetailsForm(parsedForms.sendToServerData)

    } , [detailsResponse])


    return (
        <>
            <ResponseFormListHeader detailsFlag={true}/>
            <DetailsResponseTable data={detailsForm}/>
        </>
    )
}

export default DetailsResponseForm
